<template>
  <v-container>
    <v-row wrap>
      <v-col cols="12" sm="12" md="12" lg="12" xl="12" class="mb-0 pb-0">
        <v-card flat>
          <v-card-text class="pa-0 pt-6">
            <v-row class="grey lighten-4 mx-0 py-6 px-6">
              <v-col cols="12" sm="2" class="d-none d-sm-flex text-center">
                <v-avatar :size="150" color="blue lighten-5">
                  <v-img
                    fluid
                    :src="
                      current_user && current_user.foto
                        ? current_user.foto
                        : current_user && current_user.kelamin == 'P'
                        ? 'https://cdn.siap.id/s3/simpkb/asset%20img/guru-praktik-baik/img-default-perempuan.png'
                        : 'https://cdn.siap.id/s3/simpkb/asset%20img/guru-praktik-baik/img-default-laki.png'
                    "
                  >
                  </v-img>
                </v-avatar>
              </v-col>
              <v-col cols="12" sm="8" md="8" lg="8" xl="8" class="ml-3">
                <p class="headline black--text font-weight-bold mb-0 pb-0 pt-0 mt-n1">{{ pVal(current_user, "name") }}</p>
                <p class="py-0 my-0 caption">{{ pVal(current_user, "email") }}</p>
                <p v-if="!current_user.is_super_admin && false">
                  <v-alert v-if="!current_user.komunitas_id" icon="mdi-alert" cols="12" dense text type="warning" class="caption">
                    Belum bergabung dengan komunitas tertentu &nbsp;
                    <m-button outlined x-small color="orange" class="white--text ma-0 float-sm-right" textButton="Bergabung" action="pilih" @pilih="toSIMPKB()"></m-button>
                  </v-alert>
                  <span class="caption green--text" v-else>{{ pVal(current_user, "komunitas") }}</span>
                </p>
                <p class="my-4 pt-3" v-if="current_user.peran_dapodik">
                  <v-chip label class="mr-2" color="blue lighten-5 blue--text"
                    >{{ current_user.peran_dapodik.keterangan | toTitleCase }} {{ current_user.jenjang ? current_user.jenjang.keterangan : "" }}
                  </v-chip>
                </p>
                <p class="caption mx-1 font-weight-medium pb-0 mb-1" v-for="tugas in current_user.info_guru.tugases" :key="tugas.id">
                  <strong class="black--text">NPSN {{ tugas.sekolah.npsn }}</strong> <br />{{ tugas.sekolah.nama }}
                  <span label :class="isSatminkal(tugas) ? 'green--text' : 'orange--text'">{{ isSatminkal(tugas) ? "SATMINKAL" : "NON SATMINKAL" }} </span>
                </p>
              </v-col>
            </v-row>
            <div class="py-6"></div>
            <v-row no-gutters class="grey lighten-2">
              <v-col cols="12" sm="12" md="12" lg="12" xl="12">
                <a href="https://play.google.com/store/apps/details?id=id.simpkb.app" target="_blank">
                  <v-img
                    max-width="700px"
                    :lazy-src="
                      $vuetify.breakpoint.smAndUp
                        ? 'https://cdn.siap.id/s3/simpkb/asset%20img/banner-info/Leaderboard-iklan-simpkb.png'
                        : 'https://cdn.siap.id/s3/simpkb/asset%20img/banner-info/Leaderboard-iklan-simpkb-mobile-version.png'
                    "
                    :src="
                      $vuetify.breakpoint.smAndUp
                        ? 'https://cdn.siap.id/s3/simpkb/asset%20img/banner-info/Leaderboard-iklan-simpkb.png'
                        : 'https://cdn.siap.id/s3/simpkb/asset%20img/banner-info/Leaderboard-iklan-simpkb-mobile-version.png'
                    "
                  ></v-img>
                </a>
              </v-col>
            </v-row>
            <div class="py-0"></div>
            <v-row class="align-center justify-center pt-4">
              <v-col cols="12" sm="6" md="3" lg="3">
                <m-button
                  isBlock
                  v-if="current_user.peranku.length > 0 || current_user.is_super_admin"
                  class="mt-1"
                  dark
                  color="primary lighten-1"
                  text-button="Daftar Seri"
                  icon="mdi-google-classroom"
                  action="toKelola"
                  @toKelola="mode = 1"
                ></m-button>
              </v-col>
              <v-col cols="12" sm="6" md="3" lg="3">
                <m-button
                  isBlock
                  v-if="current_user.peranku.length > 0 || current_user.is_super_admin"
                  class="mt-1"
                  dark
                  color="primary lighten-1"
                  text-button="Kelola Seri"
                  icon="mdi-cogs"
                  action="toKelola"
                  @toKelola="$router.push({ name: 'instansi.pilih.admin' })"
                ></m-button>
              </v-col>
              <v-col cols="12" sm="6" md="3" lg="3">
                <m-button
                  isBlock
                  v-if="current_user.is_super_admin"
                  class="mt-1"
                  dark
                  color="primary lighten-1"
                  text-button="Kelola Informasi"
                  icon="mdi-bullhorn"
                  action="toKelolaInfomasi"
                  @toKelolaInfomasi="mode = 2"
                ></m-button>
              </v-col>
              <v-col cols="12" sm="6" md="3" lg="3">
                <m-button
                  isBlock
                  v-if="current_user.is_super_admin"
                  class="mt-1"
                  dark
                  color="primary lighten-1"
                  text-button="Riwayat Peserta"
                  icon="mdi-account-search"
                  action="toRiwayat"
                  @toRiwayat="mode = 3"
                ></m-button>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <div class="my-4 pt-4" v-if="informasis.length > 0 && mode == 1"></div>
    <v-row v-if="informasis.length > 0 && mode == 1">
      <v-col cols="12" sm="12" md="12" lg="12" xl="12" class="my-0 py-0" v-for="info in informasis" :key="info.id">
        <v-alert class="mb-0 pb-4 mt-4" color="info" dismissible text elevation="2">
          <p class="font-weight-bold my-0 py-0">{{ info.judul }}</p>
          <div class="my-0 py-0" v-html="info.informasi"></div>
        </v-alert>
      </v-col>
    </v-row>
    <v-alert v-if="false" class="mt-8" icon="mdi-information" prominent text type="info">
      <v-row>
        <v-col class="grow">
          Bagi pengguna yang pernah mengikuti Seri sebelumnya dapat mengunduh sertifikat setiap seri pada tautan berikut
        </v-col>
        <v-col class="shrink">
          <v-btn class="success" @click="toArchieve">Tautan</v-btn>
        </v-col>
      </v-row>
    </v-alert>

    <v-alert class="mt-8" icon="mdi-information" prominent text type="info">
      <v-row>
        <v-col class="grow">
          Diklat GTK kini dilengkapi dengan fitur berkas baru yang memungkinkan pengelolaan efisien berkas yang dibutuhkan
        </v-col>
        <v-col class="shrink">
          <v-btn class="info" @click="toBerkas">Unggah Berkas</v-btn>
        </v-col>
      </v-row>
    </v-alert>

    <ListInfo class="mt-4" v-if="mode == 2" />
    <ListRiwayat class="mt-4" v-else-if="mode == 3" />
    <div v-else>
      <v-row class="px-0 pt-10">
        <v-col cols="12" class="text-h4 font-weight-bold mb-0 pb-0">Seri Tersedia</v-col>
        <v-col cols="12" sm="12" md="6" lg="6" xl="6" class="mt-2 pt-0 mb-3" v-for="item in filterSeri(items, true)" :key="item.id">
          <BlockCard
            :isKelola="false"
            :isReady="item.is_tutup ? false : item.is_rilis ? true : false"
            :title="item.nama"
            :item="item"
            :newSeries="item.is_new"
            :logo="item.cover"
            style="height: 100%"
            color="primary"
            @reload="load"
            @edit="edit(item)"
            @pilih="pilihInstansi(item)"
            to
          />
        </v-col>

        <Form ref="dlg" />
      </v-row>
      <v-row class="px-0 pt-14">
        <v-col cols="12" class="text-h4 font-weight-bold mb-0 pb-0" v-if="filterSeri(items, false).length > 0">Seri Berakhir</v-col>
        <v-col cols="12" sm="12" md="6" lg="6" xl="6" class="mt-4 pt-0 mb-3" v-for="itemClose in filterSeri(items, false)" :key="itemClose.id">
          <BlockCard
            :isReady="itemClose.is_tutup ? false : itemClose.is_rilis ? true : false"
            :title="itemClose.nama"
            :item="itemClose"
            :newSeries="itemClose.is_new"
            :logo="itemClose.cover"
            style="height: 100%"
            color="primary"
            @reload="load"
            @edit="edit(itemClose)"
            @pilih="pilihInstansi(itemClose)"
            to
          />
        </v-col>
      </v-row>
    </div>
    <NotifikasiCustom ref="dlgInfoCustom" />
    <dialog-info ref="dlgInfo" />
    <!--    <VPengisianKuesioner></VPengisianKuesioner>-->
  </v-container>
</template>

<script>
import { SIMPKB } from "@/const";
import Form from "../../user/components/Form.vue";
import ListInfo from "../../informasi/pages/List.vue";
import ListRiwayat from "../../user/pages/Pencarian.vue";
import VPengisianKuesioner from "../../instansi/pages/NotifikasiKuesioner";
import NotifikasiCustom from "../../instansi/pages/NotifikasiCustom";

function compare(a, b) {
  if (a.id < b.id) {
    return 1;
  }
  if (a.id > b.id) {
    return -1;
  }
  return 0;
}

export default {
  components: {
    BlockCard: () => import("@/components/BlockCard"),
    Form,
    ListInfo,
    ListRiwayat,
    VPengisianKuesioner,
    NotifikasiCustom
  },
  data() {
    return {
      highlightSeri: 33,
      ikutSeri: [1, 2, 36],
      instansi: {},
      textSearch: "",
      items: [],
      current_page: 1,
      hsidebar: false,
      page: null,
      cp: 1,
      dialog: true,
      jenjangs: [],
      informasis: [],
      mode: 1
    };
  },
  activated() {
    this.dialog = true;
    this.$store.commit("main/setLDrawer", false);
  },
  mounted() {
    this.$store.commit("main/setLDrawer", false);
    this.current_page = 1;

    this.load();
    this.loadInformasi();
    this.cekKuesioner();
  },
  methods: {
    add() {
      this.$refs.dlg.open().then(() => {
        this.load();
      });
    },

    updateJenjang() {
      this.$refs.dlg.open(this.current_user).then(() => {
        this.load();
      });
    },

    toArchieve() {
      this.$router.push({
        name: "instansi.archieve"
      });
    },

    cekKuesioner() {
      return this.$store.dispatch("user/cekKuesioner", {}).catch(e => e);
    },

    toBerkas() {
      this.$router.push({
        name: "user.berkas"
      });
    },

    toKelola() {
      this.$router.push({
        name: "instansi.pilih.admin"
      });
    },
    toSIMPKB() {
      window.open(SIMPKB, "_blank");
    },
    pencarian() {
      this.cp = 1;
      this.current_page = 1;
      this.load();
    },
    load() {
      return this.$store
        .dispatch("instansi/get", {
          page: this.current_page,
          s: this.textSearch
        })
        .then(res => {
          this.page = res;
          var instansiFiltered = res.filter(res => res.parent_id == 0);
          this.items = instansiFiltered.sort(compare);
        })
        .catch(e => e);
    },
    filterSeri(items, aktif) {
      if (aktif) {
        return items.filter(res => res.is_tutup == 0 && res.is_gbb == 0);
      } else {
        return items.filter(res => res.is_tutup == 1 && res.is_gbb == 0);
      }
    },
    edit(item) {
      this.$refs.dlg.open(item).then(() => {
        this.load();
      });
    },
    // eslint-disable-next-line
    save() {
      this.$validator
        .validateAll("form")
        .then(res => {
          if (!res) return Promise.reject();
          return res;
        })
        .then(() => {
          return this.$store.dispatch("instansi/create", this.instansi);
        })
        .then(res => {
          this.instansi.nama = "";
          this.pilihInstansi(res.data);
          this.$refs.dlg.resolve();
          return res;
        })
        .catch(e => e);
    },
    change() {
      this.load();
    },
    toSurvei() {
      window.open("https://formulir.kemdikbud.go.id/view.php?id=12821810", "_blank");
    },
    loadInformasi() {
      return this.$store
        .dispatch("instansi/getInformasi", 0)
        .then(res => {
          this.informasis = res.filter(r => r.jenis.id === 1);
          const infoDialog = res.filter(r => r.jenis.id === 2);
          this.$refs.dlgInfo.open(infoDialog.length > 0 ? infoDialog[0] : null);
        })
        .catch(e => e);
    },

    isSatminkal(val) {
      let satminkal = false;

      if (val.sekolah.sekolah_id == this.current_user.info_guru.sekolah.sekolah_id) {
        satminkal = true;
      }

      return satminkal;
    },

    pilihInstansi(item) {
      return this.$store
        .dispatch("instansi/switchInstansi", item.id)
        .then(() => {
          if (item.kode == "p3k") {
            return this.$router.push({
              name: "beranda.pppk",
              params: { instansi_id: item.id }
            });
          }
          if (item.subinstansi_count > 0) {
            return this.$router.push({
              name: "instansi.pilih.sub",
              params: { parent_id: item.id }
            });
          } else {
            return this.$router.push({
              name: "beranda",
              params: { instansi_id: item.id }
            });
          }
        })
        .catch(e => e);
    }
  },
  watch: {
    hsidebar(n) {
      this.$store.commit("main/setHsidebar", n);
    }
  },
  computed: {
    is_disabled() {
      return this.CONFIG.SINGKRONISASI == "true" ? true : false;
    }
  }
};
</script>

<style></style>
